import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Avatar,
  Rating,
} from '@mui/material';
import { FormatQuote } from '@mui/icons-material';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Sarah Meli',
      role: 'First-time Land Buyer',
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150',
      rating: 5,
      text: 'The team made my first land buying experience incredibly smooth. Their expertise and guidance helped me find the perfect property within my budget.',
    },
    {
      name: 'Michael Kariuki',
      role: 'Property Investor',
      avatar: '',
      rating: 5,
      text: 'Outstanding service! They provided excellent market analysis that helped me make profitable investment decisions. Highly recommended for serious investors.',
    },
    {
      name: 'Emily Moraa',
      role: 'Land Seller',
      avatar: '',
      rating: 5,
      text: 'Sold my house in just 2 weeks! Their marketing strategy and professional photography really made my property stand out in the market.',
    }
  ];

  return (
    <Box sx={{ py: 8, backgroundColor: '#f8f9fa' }}>
      <Container maxWidth="lg">
        <Box textAlign="center" sx={{ mb: 6 }}>
          <Typography
            variant="h3"
            component="h2"
            sx={{
              fontWeight: 700,
              mb: 2,
              background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            What Our Clients Say
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto' }}>
            Real stories from satisfied clients who found their perfect properties with our help
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {testimonials.map((testimonial, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card
                sx={{
                  height: '100%',
                  p: 3,
                  borderRadius: 3,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  border: '1px solid #e0e0e0',
                  transition: 'all 0.3s ease-in-out',
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                  },
                }}
              >
                <FormatQuote
                  sx={{
                    position: 'absolute',
                    top: 16,
                    right: 16,
                    fontSize: 32,
                    color: '#e0e0e0',
                    transform: 'rotate(180deg)',
                  }}
                />
                
                <CardContent sx={{ p: 0, '&:last-child': { pb: 0 }, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                  <Rating
                    value={testimonial.rating}
                    readOnly
                    sx={{ mb: 2 }}
                  />
                  
                  <Typography
                    variant="body1"
                    sx={{
                      mb: 3,
                      lineHeight: 1.6,
                      fontStyle: 'italic',
                      color: '#555',
                    }}
                  >
                    "{testimonial.text}"
                  </Typography>
                  
                  <Box sx={{ mt: 'auto' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Avatar
                        src={testimonial.avatar || undefined}
                        alt={testimonial.name}
                        sx={{ width: 56, height: 56, mr: 2, bgcolor: 'primary.main' }}
                      >
                        {!testimonial.avatar && testimonial.name.charAt(0)}
                      </Avatar>
                      <Box>
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: 600, mb: 0.5 }}
                        >
                          {testimonial.name}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                        >
                          {testimonial.role}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default TestimonialsSection;
